<template>
  <div>
    <div
      class="landing-page-search-content landing-page-search-content_second"
    >
      <selectWithKeyTemplate
        :settings="serviceSelectSettings"
        @changeSelect="setActiveServicesType($event)"
      />
    </div>
  </div>
</template>

<script>
import selectWithKeyTemplate from '@/components/fields/selectWithKeyTemplate';

export default {
  name: 'StepSecond',
  components: {
    selectWithKeyTemplate,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    activeServiceTypes: {
      type: String,
      default: () => '',
    },
    isDefault: {
      type: Boolean,
      default: () => false,
    },
    disableSecondStep: {
      type: Boolean,
      default: () => true,
    },
  },
  computed: {
    selectServicesList() {
      const newArr = [];
      this.allTypeServices.forEach((item) => {
        newArr.push({
          text: item.name[this.language],
          key: item._id,
        });
      });
      return newArr;
    },
    serviceSelectSettings() {
      return {
        optionList: this.selectServicesList,
        placeholderText: this.$t('stepsModal.selectTypeOfService'),
        selectedKey: this.activeServiceTypes,
        disable: this.disableSecondStep,
        toTop: false,
        tabindex: 1,
        selectClass: 'select_alt',
      };
    },
    language() {
      return this.$i18n.locale;
    },
    allTypeServices() {
      return this.items;
    },
  },
  beforeMount() {
    if (this.selectServicesList.length === 1) {
      const activeKey = this.selectServicesList[0].key;
      this.setActiveServicesType(activeKey);
    }
  },
  methods: {
    setActiveServicesType(id) {
      this.$emit('setActiveServicesType', id);
      this.$nextTick(() => {
        if (this.isDefault) {
          this.$emit('selectedServicesType');
          this.$emit('setActiveStep', 3);
        } else {
          this.$emit('setActiveStep', 2);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../sass/variables";
@import "../../../sass/mixins";

.landing-page-search {

  &-content {
    margin: 18px auto 0;

    &__item {
      border: 1px solid $color-gallery;
      border-radius: $borderRadius;
      min-height: 60px;
      padding: 19px 90px;
      color: $color-silver-chalice;
      width: auto;
      align-items: center;
      justify-content: center;
      display: inline-flex;
      margin: 0 6px 12px;
      text-align: center;
      cursor: pointer;
      transition: opacity .15s ease-in;
      user-select: none;

      &:hover {
        opacity: .8;
      }

      &_active {
        border-color: $color-dodger-blue;
        color: $color-dodger-blue;
      }
    }

    &__slider {
      cursor: pointer;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      width: 114px;
      height: 114px;

      &_active {
        border: 1px solid $color-dodger-blue;
        border-radius: $borderRadius;
      }

      &-text {
        font: $font-size-sm $font-landing-global;
        color: $color-silver-chalice;
        text-align: center;
        margin-top: 6px;

        &_active {
          color: $color-dodger-blue;
          font: $font-size-base $font-landing-global;
        }
      }
    }
  }

  &-btn {
    display: flex;
    justify-content: flex-end;
    margin-top: 65px;

    &_second {
      margin-top: 57px;
    }

    button {
      height: 53px;
      padding: 0 30px;
      border-radius: 0;
    }

    &_disable {
      border-color: $color-silver-chalice;
      pointer-events: none;
      color: rgba($color-white, .4);
    }

    &_margin {
      margin-top: 40px;
    }
  }
}

@include tablet-portrait {
  .landing-page-search {
    &-content {
      display: flex;
      justify-content: center;
    }
  }
}

@include mobile {
  .landing-page-search {
    &-content {
      min-height: auto;
    }

    &-btn {
      margin-top: 84px;

      button {
        margin: auto;
      }
    }
  }
}
</style>
